import { tap } from "rxjs";
import { Injectable } from "@angular/core";

import { PaymentPayload } from "../../interfaces";

import { HttpService } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class PaymentService extends HttpService {
  protected override get baseUrl(): string {
    return "payment/";
  }

  addPayment(body: Partial<PaymentPayload>) {
    return this.post<string>({ APIName: "pay", body }).pipe(
      tap((data) => {
        if (!data) return;

        // navigating to the payment provider page.
        const id = data.split("?id=").pop();
        const URL = data.split("?id=").shift();

        if (id) localStorage.setItem("requestId", btoa(id));
        if (body.paymentMethod) window.open(window.location.origin.includes("localhost") ? data : URL, "_self");
        else window.location.reload();
      }),
    );
  }
}
